export default __webpack_public_path__ + "static/media/dbs.57b7c479.png";